const OWN_MEDIA_HOST = /^portal-r5id-images\.s3(?:\.us-east-1)?\.amazonaws\.com$/;
const LEGACY_CARDS = {
  '/uploads/839b9034-37bc-49ba-a239-8b3845790053-Foto-284.jpg': 'foto-284',
  '/uploads/6c936d30-2fec-4bcd-af1b-4b022e4c6267-dce30c03-b8c0-442f-85a4-a39705fd2294-hero-noticia.jpeg': 'hero-noticia',
  '/uploads/50ef3fa6-5fce-4626-9f5d-a137ada5f915-Imagem.png': 'amcham',
  '/uploads/53654fef-f155-4795-9b4e-ce915b838311-Imagem17-02-2026as00.53.png': 'noticia-1702'
};
const HERO_VIDEO = '/videos/1765765373321-Ajuste_de_Cena_e_Estilo_Visual.mp4';
const ownedUrl = value => {
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && OWN_MEDIA_HOST.test(url.hostname) && !url.search ? url : null;
  } catch { return null; }
};

// Only curated originals and new uploads explicitly marked by our API get variants.
export const getCardImageUrl = original => {
  const url = ownedUrl(original);
  if (!url) return original;
  const legacy = LEGACY_CARDS[url.pathname];
  if (legacy) return `/assets/media/performance/${legacy}.card-v1.webp`;
  if (/^\/uploads\/card-v1\/[a-f0-9-]{36}-.+$/i.test(url.pathname) && !url.pathname.endsWith('.card-960.webp')) {
    url.pathname += '.card-960.webp';
    return url.href;
  }
  return original;
};

export const getHeroPoster = source =>
  ownedUrl(source)?.pathname === HERO_VIDEO ? '/assets/media/performance/hero-poster-v1.webp' : undefined;

// One retry to the preserved original, then one to the existing local fallback.
export const handleCardImageError = (event, original) => {
  const image = event.currentTarget;
  const step = Number(image.dataset.cardFallback || 0);
  if (step >= 2) return;
  image.dataset.cardFallback = String(step + 1);
  image.src = step === 0 && original && !original.startsWith('/images/hero.png')
    ? original : '/images/hero.png';
};
